export enum PAGES {
	HOME = 'workflow',
}

/**
 * The Workflow remote (motorway/mw-workflow-admin) publishes itself into Engine's own bucket under
 * remotes/workflow/. The manifest's URL never changes, so its deploy uploads mf-manifest.json and
 * remoteEntry.js `no-cache`; everything they point at is fingerprinted.
 */
export const REMOTE = {
	NAME: 'workflow',
	MANIFEST_PATH: '/remotes/workflow/mf-manifest.json',
} as const;
